import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthHandlerService } from 'src/app/auth/auth-handler.service';
import { CompassAPIExcursionItineraryService } from 'src/app/shared/api-compass/compass-api-excursion-itinerary.service';
import { CompassApiGetResults } from 'src/app/shared/models/compass-api-get-results.interface';
import { ExcursionItinerary } from 'src/app/shared/models/excursion-itineraries.interface';
import { UserAppAccess } from 'src/app/shared/models/user-app-access.interface';

@Component({
	selector: 'app-travel-board-chooser',
	templateUrl: './travel-board-chooser.component.html'
})
export class TravelBoardChooserComponent implements OnInit {

	public cancel: EventEmitter<any> = new EventEmitter<any>();
	public selectBoard: EventEmitter<any> = new EventEmitter<any>();
	public createBoard: EventEmitter<any> = new EventEmitter<any>();
	//public chooseBoard: EventEmitter<any> = new EventEmitter<any>();

	public productId: string;

	public boards$: Observable<ExcursionItinerary[]>;

	public userAppAccess: UserAppAccess;

	constructor(
		private _authHandlerService: AuthHandlerService,
		private _compassAPIExcursionItineraryService: CompassAPIExcursionItineraryService,
		public modalService: BsModalService,
		private modalRef: BsModalRef
	) { }


	ngOnInit(): void {
		//console.log('TravelBoardChooserComponent.productId:', this.productId);
		this.userAppAccess = this._authHandlerService.getUserAppAccess();
		// console.log('userAppAccess: ', this.userAppAccess);

		this.getExcursionItineraries();
	}


	public getExcursionItineraries() {
		//note: API was named this before we switched to Travel Board
		//console.log('TravelBoardChooserComponent.getExcursionItineraries');


		this.boards$ = this._compassAPIExcursionItineraryService.getExcursionItineraries(null, null, null, true, this.userAppAccess.activeAccount.localAccountId)
			.pipe(map((res: CompassApiGetResults) => {
				if(res && res.results.length > 0) {
					//console.log('boards$:', res);
					return res.results;
				}
				return null;
			}));
		
	}



	public closeModal() {
		this.cancel.emit();
		this.modalRef?.hide();
	}

	public onSelectBoard(board: ExcursionItinerary) {
		// console.log('TravelBoardChooserComponent.onSelectBoard.productId:', this.productId);
		// console.log('TravelBoardChooserComponent.onSelectBoard.board:', board);
		//hit api, then close modal and alert parent
		this.selectBoard.emit({productId: this.productId, board: board});
		//this.modalRef?.hide();
	}

	public onCreateBoard() {
		//console.log('TravelBoardChooserComponent.onCreateBoard.productId:', this.productId);
		this.createBoard.emit({productId: this.productId});
		//this.modalRef?.hide();
	}

}
